import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Pillars from "@/components/landing/Pillars";
import Stats from "@/components/landing/Stats";
import WhatWeDo from "@/components/landing/WhatWeDo";
import Gallery from "@/components/landing/Gallery";
import CTASection from "@/components/landing/CTASection";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import ScrollReveal from "@/components/motion/ScrollReveal";

export default function Home() {
    return (
        <main
            data-testid="landing-page"
            className="min-h-screen bg-[#FAFAFA] text-zinc-950 overflow-x-hidden"
        >
            <Header />
            <Hero />
            <ScrollReveal>
                <Pillars />
            </ScrollReveal>
            <ScrollReveal delay={0.05}>
                <Stats />
            </ScrollReveal>
            <ScrollReveal delay={0.05}>
                <WhatWeDo />
            </ScrollReveal>
            <ScrollReveal variant="scaleIn">
                <Gallery />
            </ScrollReveal>
            <ScrollReveal variant="fadeIn">
                <CTASection />
            </ScrollReveal>
            <ScrollReveal>
                <FAQ />
            </ScrollReveal>
            <Footer />
        </main>
    );
}
